// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import * as PropTypes from 'prop-types';

import {OrganizationDefaultSchemaCollaboratorsConfiguration} from 'auth/__generated/OrganizationDefaultSchemaCollaboratorsConfiguration';
import {DefaultSchemaCollaborator} from 'auth/DefaultSchemaCollaboratorsConfigurationDAO';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {EntitySummary} from 'constants/UserConstants';
import {OrganizationPermissionRole, TeamPermissionRole} from 'orgs/OrganizationConstants';
import {
  PARTY_GRAPHQL_TYPENAME_TO_PARTY_TYPE,
  PARTY_TYPE_TO_GRAPHQL_TYPENAME,
  PartyType,
} from 'parties/PartyConstants';

import {DefaultSchemaCollaborationConfigurationsListingQuery} from './settings/__generated/DefaultSchemaCollaborationConfigurationsListingQuery';

type DefaultSchemaConfigurations = NonNullable<
  DefaultSchemaCollaborationConfigurationsListingQuery['currentTenantOrganizations']
>[number]['schemaCollaborationDefaultConfigurations'][number];
type Organization = NonNullable<
  DefaultSchemaCollaborationConfigurationsListingQuery['currentTenantOrganizations']
>[number];
type DefaultSchemaCollaboratorsConfiguration =
  OrganizationDefaultSchemaCollaboratorsConfiguration['schemaCollaborationDefaultConfigurations'][number];

export enum PermissionLevel {
  NO_PERMISSION = 1000000, // Needs to match the Permission.NO_PERMISSION value on the server
  READ = 200,
  APPEND = 100,
  WRITE = 1,
  ADMIN = 0,
}

export const OBJECTS_CREATABLE_PERMISSION: keyof Permissions = 'objectsCreatable';
export const OBJECTS_REGISTERABLE_PERMISSION: keyof Permissions = 'objectsRegisterable';

export interface Permissions {
  readable: boolean;
  writable: boolean;
  appendable: boolean;
  admin: boolean;
  movable?: boolean | null;
  deletable?: boolean | null;
  archivable?: boolean | null;
  unarchivable?: boolean | null;
  tagsEditable?: boolean;
  chemicalStructureEditable?: boolean | null;
  polymerFeaturesEditable?: boolean;
  polymerResiduesEditable?: boolean;
  structurePredictionEditable?: boolean;
  subfolderCreatable?: boolean;
  unregisterable?: boolean;
  registryIdsChangeable?: boolean;
  canEditNamesAndAliases?: boolean;
  bioentitiesAppendable?: boolean;
  batchesWritable?: boolean;
  locationsCreatable?: boolean;
  canAccept?: boolean;
  canCreateEntriesFromDraftTemplates?: boolean;
  canCreateRequest?: boolean;
  canCreateTeams?: boolean | null;
  canReject?: boolean;
  canRetract?: boolean;
  canSendForReview?: boolean;
  canReassignRlcReviewer?: boolean;
  canExecuteRequest?: boolean;
  canEditBarcodes?: boolean;
  canEditContainer?: boolean;
  canEditNamesAndBarcodes?: boolean;
  canEditRestrictedSampleUsers?: boolean;
  canEditStatus?: boolean;
  canManageCollaborators?: boolean | null;
  canRestrictSamples?: boolean;
  canUnrestrictSamples?: boolean;
  definitionEditable?: boolean;
  definitionListable?: boolean;
  definitionDeletable?: boolean;
  objectsCreatable?: boolean;
  objectsRegisterable?: boolean;
  owner?: boolean;
  canChangeStudyableAssignment?: boolean;
}

export interface BasicPermissionsGraphQL {
  __typename: 'PermissionsNode';
  admin: boolean;
  appendable: boolean;
  readable: boolean;
  writable: boolean;
}

export interface HasOwnablePermissions {
  id: string;
  permissions: Permissions;
}

export interface HasPoliceablePermissions extends HasOwnablePermissions {}

export interface MinimalFolderPermissions {
  subfolderCreatable?: boolean;
}

export type CollaboratorType = PartyType;

export const PERMISSIONS_SHAPE = PropTypes.shape({
  readable: PropTypes.bool.isRequired,
  writable: PropTypes.bool.isRequired,
  appendable: PropTypes.bool.isRequired,
  admin: PropTypes.bool.isRequired,
  movable: PropTypes.bool, // not present for folders
  deletable: PropTypes.bool, // only present for folders, folder items, and sources
  tagsEditable: PropTypes.bool, // only present for entries and stage entries
  chemicalStructureEditable: PropTypes.bool, // only present for molecules
  polymerFeaturesEditable: PropTypes.bool, // only present for sequences and proteins
  polymerResiduesEditable: PropTypes.bool, // only present for sequences and proteins
  structurePredictionEditable: PropTypes.bool, // only present for sequences and proteins
  subfolderCreatable: PropTypes.bool, // only present for projects and folders
  locationsCreatable: PropTypes.bool, // only present for registries
  unregisterable: PropTypes.bool, // only present for bioentities
  registryIdsChangeable: PropTypes.bool, // only present for bioentities
  bioentitiesAppendable: PropTypes.bool, // only present for bioentities
  batchesWritable: PropTypes.bool, // only present for bioentities
  definitionEditable: PropTypes.bool, // only present for schemas
  objectsCreatable: PropTypes.bool, // only present for schemas
  objectsRegisterable: PropTypes.bool, // only present for schemas
  canChangeStudyableAssignment: PropTypes.bool, // only present for projects and folders
});

export const DATA_POLICY_COLLABORATOR_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  dataPolicyId: PropTypes.string,
  memberDataPolicyId: PropTypes.string,
  adminDataPolicyId: PropTypes.string,
  type: PropTypes.oneOf([
    ModelTypeConstants.USER,
    ModelTypeConstants.ORGANIZATION,
    ModelTypeConstants.TEAM,
    ModelTypeConstants.BENCHLING_APP,
    ModelTypeConstants.ROUTINE,
  ]).isRequired,
  auditor: PropTypes.bool,
});

export const SCHEMA_POLICY_COLLABORATOR_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  schemaPolicyId: PropTypes.string,
  memberSchemaPolicyId: PropTypes.string,
  adminSchemaPolicyId: PropTypes.string,
  type: PropTypes.oneOf([
    ModelTypeConstants.USER,
    ModelTypeConstants.ORGANIZATION,
    ModelTypeConstants.TEAM,
    ModelTypeConstants.BENCHLING_APP,
    ModelTypeConstants.ROUTINE,
  ]).isRequired,
  auditor: PropTypes.bool,
});

export const COLLABORATOR_SHAPE = PropTypes.oneOfType([
  DATA_POLICY_COLLABORATOR_SHAPE,
  SCHEMA_POLICY_COLLABORATOR_SHAPE,
]);

export type Owner = EntitySummary;

export interface OwnerInfo {
  type: string;
  memberDataPolicyId: string | null;
}

export enum PolicyType {
  DATA = 'data',
  SCHEMA = 'schema',
}

// Future/ideal design: use generic User and Group Collaborator interfaces with a single policyId property
interface BaseActorCollaborator {
  id: string;
  handle: string;
  name: string;
  type: ModelTypeConstants.USER | ModelTypeConstants.BENCHLING_APP | ModelTypeConstants.ROUTINE;
  auditor?: boolean;
  owner?: boolean;
  avatar_url?: string;
  url_identifier?: string;
}
export interface SchemaPolicyActorCollaborator extends BaseActorCollaborator {
  schemaPolicyId: string;
}

export interface DataPolicyActorCollaborator extends BaseActorCollaborator {
  dataPolicyId: string;
}

export type ActorCollaborator = SchemaPolicyActorCollaborator | DataPolicyActorCollaborator;

export function isDataPolicyActorCollaborator(
  collaborator: Collaborator
): collaborator is DataPolicyActorCollaborator {
  return (collaborator as DataPolicyActorCollaborator).dataPolicyId !== undefined;
}

export function isSchemaPolicyActorCollaborator(
  collaborator: Collaborator
): collaborator is SchemaPolicyActorCollaborator {
  return (collaborator as SchemaPolicyActorCollaborator).schemaPolicyId !== undefined;
}

type GroupCollaboratorType = ModelTypeConstants.ORGANIZATION | ModelTypeConstants.TEAM;

interface BaseGroupCollaborator {
  id: string;
  handle: string;
  name: string;
  type: GroupCollaboratorType;
  auditor?: boolean;
  owner?: boolean;
  avatar_url?: string;
  joinedOn?: string;
  url_identifier?: string;
}
export interface SchemaPolicyGroupCollaborator extends BaseGroupCollaborator {
  adminSchemaPolicyId: string | null;
  memberSchemaPolicyId: string | null;
}

export interface DataPolicyGroupCollaborator extends BaseGroupCollaborator {
  adminDataPolicyId: string | null;
  memberDataPolicyId: string | null;
}

export type GroupCollaborator = SchemaPolicyGroupCollaborator | DataPolicyGroupCollaborator;

export function isActorCollaborator(collaborator: Collaborator): collaborator is ActorCollaborator {
  return (
    collaborator.type === ModelTypeConstants.USER ||
    collaborator.type === ModelTypeConstants.BENCHLING_APP ||
    collaborator.type === ModelTypeConstants.ROUTINE
  );
}

export function isDataPolicyGroupCollaborator(
  collaborator: Collaborator
): collaborator is DataPolicyGroupCollaborator {
  return (collaborator as DataPolicyGroupCollaborator).adminDataPolicyId !== undefined;
}

export function isSchemaPolicyGroupCollaborator(
  collaborator: Collaborator
): collaborator is SchemaPolicyGroupCollaborator {
  return (collaborator as SchemaPolicyGroupCollaborator).adminSchemaPolicyId !== undefined;
}

export type DataPolicyCollaborator = DataPolicyActorCollaborator | DataPolicyGroupCollaborator;
export type SchemaPolicyCollaborator = SchemaPolicyActorCollaborator | SchemaPolicyGroupCollaborator;
export type Collaborator = DataPolicyCollaborator | SchemaPolicyCollaborator;

type SchemaActorCollaborator = Pick<SchemaPolicyActorCollaborator, 'id' | 'schemaPolicyId'>;
type SchemaGroupCollaborator = Pick<
  SchemaPolicyGroupCollaborator,
  'id' | 'adminSchemaPolicyId' | 'memberSchemaPolicyId'
>;
export type SchemaCollaborator = SchemaActorCollaborator | SchemaGroupCollaborator;

type DataActorCollaborator = Pick<DataPolicyActorCollaborator, 'id' | 'dataPolicyId'>;
type DataGroupCollaborator = Pick<
  DataPolicyGroupCollaborator,
  'id' | 'adminDataPolicyId' | 'memberDataPolicyId'
>;
export type DataCollaborator = DataActorCollaborator | DataGroupCollaborator;

export const OWNER_INFO_SHAPE = PropTypes.shape({
  type: PropTypes.oneOf([
    ModelTypeConstants.USER,
    ModelTypeConstants.BENCHLING_APP,
    ModelTypeConstants.ORGANIZATION,
  ]).isRequired,
  memberDataPolicyId: PropTypes.string,
});

export default {
  // TODO(typescript): Use the enum instead of exporting named values, using the name "ADMIN" in importing
  // code isn't very descriptive
  NO_PERMISSION: PermissionLevel.NO_PERMISSION,
  READ: PermissionLevel.READ,
  APPEND: PermissionLevel.APPEND,
  WRITE: PermissionLevel.WRITE,
  ADMIN: PermissionLevel.ADMIN,

  PERMISSIONS_SHAPE,
};

export interface Ownable {
  name: string;
  prefix: string;
  owner: Owner;
  ownerInfo: OwnerInfo;
  collaborators: Array<Collaborator>;
  description?: string;
}

export interface PoliceableInfo {
  id: string;
  name: string;
  collaborators: Array<Collaborator>;
  description?: string;
}

type CollaborationTypename =
  | 'OrganizationNode'
  | 'UserNode'
  | 'TeamNode'
  | 'BenchlingAppNode'
  | 'RoutinePrincipalNode';

export function getCollaborationTypename(
  collaboratorType: CollaboratorType | GroupCollaboratorType
): CollaborationTypename {
  return PARTY_TYPE_TO_GRAPHQL_TYPENAME[collaboratorType] as CollaborationTypename;
}

function getCollaboratorType(
  collaborationTypename: CollaborationTypename | 'ServiceAccountActorNode'
): CollaboratorType | GroupCollaboratorType | null {
  if (collaborationTypename === 'ServiceAccountActorNode') {
    return null;
  }
  return PARTY_GRAPHQL_TYPENAME_TO_PARTY_TYPE[collaborationTypename];
}

export function convertToCollaborators(
  defaultSchemaConfig: DefaultSchemaConfigurations | DefaultSchemaCollaboratorsConfiguration | undefined,
  currentOrganization: Organization | OrganizationDefaultSchemaCollaboratorsConfiguration
): Array<Collaborator> {
  if (defaultSchemaConfig == null) {
    return [];
  }
  const defaultSchemaCollaborations = defaultSchemaConfig.defaultSchemaCollaborations.map((collaboration) => {
    const collaborationType = getCollaboratorType(collaboration.party.__typename);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const converted: Record<string, any> = {
      id: collaboration.party.id,
      handle: collaboration.party.handle,
      name: collaboration.party.name,
      type: collaborationType,
      owner: false,
    };
    if (collaborationType === ModelTypeConstants.ORGANIZATION && converted.id === currentOrganization.id) {
      converted.owner = true;
    }
    if (
      collaboration.organizationRole === OrganizationPermissionRole.ADMIN ||
      collaboration.teamRole === TeamPermissionRole.ADMIN
    ) {
      converted.adminSchemaPolicyId = collaboration.policy.id;
      converted.memberSchemaPolicyId = null;
    } else if (
      collaboration.organizationRole === OrganizationPermissionRole.MEMBER ||
      collaboration.teamRole === TeamPermissionRole.MEMBER
    ) {
      converted.memberSchemaPolicyId = collaboration.policy.id;
      converted.adminSchemaPolicyId = null;
    } else {
      converted.schemaPolicyId = collaboration.policy.id;
    }
    return converted as Collaborator;
  });
  const mergedDefaultSchemaCollaborations = defaultSchemaCollaborations.reduce(
    (existingCollaborations: Array<Collaborator>, collaboration: Collaborator) => {
      const sameCollaboration = existingCollaborations.find(
        (c) => c.id === collaboration.id
      ) as SchemaPolicyGroupCollaborator;
      if (sameCollaboration) {
        if ((collaboration as SchemaPolicyGroupCollaborator).memberSchemaPolicyId) {
          sameCollaboration.memberSchemaPolicyId = (
            collaboration as SchemaPolicyGroupCollaborator
          ).memberSchemaPolicyId;
        } else if ((collaboration as SchemaPolicyGroupCollaborator).adminSchemaPolicyId) {
          sameCollaboration.adminSchemaPolicyId = (
            collaboration as SchemaPolicyGroupCollaborator
          ).adminSchemaPolicyId;
        }
      } else {
        existingCollaborations.push(collaboration);
      }
      return existingCollaborations;
    },
    []
  );
  return mergedDefaultSchemaCollaborations;
}

export function convertToDefaultCollaborators(
  collaborators: Array<Collaborator>
): Array<DefaultSchemaCollaborator> {
  const defaultCollaboratorConfigs: Array<DefaultSchemaCollaborator> = [];
  collaborators.forEach((collaborator) => {
    if (isSchemaPolicyActorCollaborator(collaborator)) {
      defaultCollaboratorConfigs.push({
        schemaPolicyId: collaborator.schemaPolicyId,
        partyId: collaborator.id,
      });
    } else if (
      isSchemaPolicyGroupCollaborator(collaborator) &&
      collaborator.type === ModelTypeConstants.ORGANIZATION
    ) {
      if (collaborator.adminSchemaPolicyId) {
        defaultCollaboratorConfigs.push({
          schemaPolicyId: collaborator.adminSchemaPolicyId,
          partyId: collaborator.id,
          organizationRole: OrganizationPermissionRole.ADMIN,
        });
      }
      if (collaborator.memberSchemaPolicyId) {
        defaultCollaboratorConfigs.push({
          schemaPolicyId: collaborator.memberSchemaPolicyId,
          partyId: collaborator.id,
          organizationRole: OrganizationPermissionRole.MEMBER,
        });
      }
    } else if (
      isSchemaPolicyGroupCollaborator(collaborator) &&
      collaborator.type === ModelTypeConstants.TEAM
    ) {
      if (collaborator.adminSchemaPolicyId) {
        defaultCollaboratorConfigs.push({
          schemaPolicyId: collaborator.adminSchemaPolicyId,
          partyId: collaborator.id,
          teamRole: TeamPermissionRole.ADMIN,
        });
      }
      if (collaborator.memberSchemaPolicyId) {
        defaultCollaboratorConfigs.push({
          schemaPolicyId: collaborator.memberSchemaPolicyId,
          partyId: collaborator.id,
          teamRole: TeamPermissionRole.MEMBER,
        });
      }
    }
  });
  return defaultCollaboratorConfigs;
}

// The following constants are for the new granular permissions UI. Most of the constants above will be
// deprecated in favor of these and autogenerated shapes from graphql fragments.

// Internal API shapes used to POST/PATCH the Collaborations for a resource.

interface CollaborationBase {
  collaborator: {
    partyId: string;
    partyRole?: OrganizationPermissionRole | TeamPermissionRole;
  };
  policyId: string;
  auditor: boolean;
  fromOwnership: boolean;
}

export interface CollaborationUpdate extends CollaborationBase {
  id: string;
}

export interface CollaborationCreate extends CollaborationBase {}

export type CollaborationCreateOrUpdate = CollaborationCreate | CollaborationUpdate;
